import React, { useEffect, useState } from "react";
import { ProjectAPI,BlobAPI } from "../services/api";
import { useNavigate } from "react-router-dom";
import { SessionAPI } from "../services/api";
import { useSession } from "../context/SessionContext";

const Projects = () => {
  const [projects, setProjects] = useState<any[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const [activeTab, setActiveTab] = useState("projects");

  const userName = localStorage.getItem("userName");
  const userNo = localStorage.getItem("userNo");
  const userType = localStorage.getItem("userType")?.toLowerCase();
  const isAdmin = userType === "admin" || userType === "superadmin";

  const isSuperAdmin = userType === "superadmin";

  const navigate = useNavigate();
  const { setSessionNo } = useSession();

  const [form, setForm] = useState({
    projectName: "",
    projectDescription: "",
    startDate: "",
    image: null as File | null,
  });

  

  
const colors = [
  "from-slate-400 to-slate-600",
  "from-gray-400 to-gray-600",
  "from-zinc-400 to-zinc-600",
  "from-neutral-400 to-neutral-600",
];

  // ✅ Stable color generator
  const getColor = (name: string) => {
    const index =
      name
        .split("")
        .reduce((acc, char) => acc + char.charCodeAt(0), 0) %
      colors.length;
    return colors[index];
  };

  useEffect(() => {
    loadProjects();
  }, []);

 
  const loadProjects = async () => {
  try {
    const data = await ProjectAPI.getAll();

    const projectsWithImages = await Promise.all(
      data.map(async (p: any) => {
        try {
          //const imageUrl = await BlobAPI.get("Project", p.projectNo);
          const imageUrl = await BlobAPI.getImage("Project", p.projectNo);
          return { ...p, imageUrl };
        } catch {
          return { ...p, imageUrl: null };
        }
      })
    );

    setProjects(projectsWithImages);
  } catch (err) {
    console.error(err);
  }
};

const openTrialProject = async () => {
  try {
    const trialProjectNo = 67;

    sessionStorage.clear();

    const session = await SessionAPI.create(
      trialProjectNo,
      Number(userNo)
    );

    setSessionNo(session.sessionNo);

    navigate(`/project/${trialProjectNo}`, {
      state: {
        projectName: "Trial Project",
      },
    });

  } catch (err) {
    console.error(err);
    alert("Unable to open Trial Project");
  }
};

const openSampleProject = async () => {
  try {
    const sampleProjectNo = 24;

    sessionStorage.clear();

    const session = await SessionAPI.create(
      sampleProjectNo,
      Number(userNo)
    );

    setSessionNo(session.sessionNo);

    // Open only Sample Project NLBD screen
    navigate(`/project/${sampleProjectNo}/third`, {
      state: {
        projectName: "Sample Project",
      },
    });
  } catch (err) {
    console.error(err);
    alert("Unable to open Sample Project");
  }
};

  // ✅ Filter without extra state
  const filteredProjects = projects.filter((p) =>
    p.projectName.toLowerCase().includes(search.toLowerCase())
  );


const handleCreate = async () => {
  if (!form.projectName || !form.projectDescription || !form.startDate) {
    alert("All fields are required");
    return;
  }

  try {
    setLoading(true);

    // Create project
    const formData = new FormData();
    formData.append("projectName", form.projectName);
    formData.append("projectDescription", form.projectDescription);
    formData.append("startDate", form.startDate);

    const data = await ProjectAPI.create(formData);

    const projectNo = Number(data?.projectNo);
    if (!Number.isFinite(projectNo)) {
      throw new Error("Project number was not returned from API");
    }

    // Upload image
    if (form.image) {
      await BlobAPI.uploadFileOnly(form.image, {
        containerName: "project-images",
        entityType: "Project",
        entityNo: projectNo,
        project: projectNo,
        sno: 1,
      });
    }

    alert("Project and image uploaded successfully");

    setShowModal(false);
    setForm({
      projectName: "",
      projectDescription: "",
      startDate: "",
      image: null,
    });

    await loadProjects();
  } catch (err: any) {
    console.error("CREATE ERROR:", err);

    const msg =
      typeof err?.response?.data === "string"
        ? err.response.data
        : err?.response?.data?.message ||
          err?.message ||
          "Request failed";

    alert(msg);
  } finally {
    setLoading(false);
  }
};




  return (
    // <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-200 p-6">
    <div
  className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-200 p-6"
  style={{
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: "13px",
    fontWeight: 400,
  }}
>

      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <div>
          <h1 className="text-3xl font-bold text-gray-800"
            style={{ fontFamily: "'Segoe UI', sans-serif" }}>
            Welcome, {userName || "User"}
          </h1>
          {/* <p className="text-sm text-gray-500"> */}
          <p className="text-gray-500">
            {projects.length} Projects
          </p>
        </div>

        <div className="flex gap-3">

          {isSuperAdmin && (
  <button
   // onClick={() => navigate("/add-user")}

   onClick={() => {
  setActiveTab("superadmin");
  navigate("/add-user");
}}
   
   //className=" text-gray-700 px-1 py-1 "
  // className="text-gray-700 px-1 py-2 border-b-2 border-blue-600"
  className={`px-4 py-2 border-b-2 ${
  activeTab === "superadmin"
    ? "border-[#5F5FEA] text-[#5F5FEA] font-semibold"
    : "border-transparent text-gray-700 hover:border-[#5F5FEA] hover:text-[#5F5FEA]"
}`}
  >
    Super Admin
  </button>
)}
          {isAdmin && (
            <button
           //   onClick={() => setShowModal(true)}

           onClick={() => {
  setActiveTab("createproject");
  setShowModal(true);
}}
             
              //className="text-gray-700 px-1 py-1  "
              className={`px-4 py-2 border-b-2 ${
  activeTab === "createproject"
    ? "border-[#5F5FEA] text-gray-700 font-semibold"
    : "border-transparent text-gray-700 hover:border-[#5F5FEA] hover:text-[#5F5FEA]"
}`}
            >
              Create Project
            </button>
          )}
<button
  onClick={openTrialProject}
  className="px-4 py-2 border-b-2 border-transparent text-gray-700 hover:border-[#5F5FEA] hover:text-[#5F5FEA]"
>
  Trial Project
</button>
<button
  type="button"
  onClick={openSampleProject}
  className="px-4 py-2 border-b-2 border-transparent text-gray-700 hover:border-[#5F5FEA] hover:text-[#5F5FEA]"
>
  Sample Project
</button>
          <button
           /*  onClick={() => {
              localStorage.clear(); // ✅ fixed
               setSessionNo(null); // ✅ ADD THIS LINE
              navigate("/login");
            }} */
           onClick={() => {
  setActiveTab("logout");
  localStorage.clear();
  setSessionNo(null);
  navigate("/login");
}}
         
          // className=" text-gray-700 px-1 py-1 "
          className={`px-4 py-2 border-b-2 ${
  activeTab === "logout"
    ? "border-[#5F5FEA] text-gray-700 font-semibold"
    : "border-transparent text-gray-700 hover:border-[#5F5FEA] hover:text-[#5F5FEA]"
}`}
          >
            Logout
          </button>
        </div>
      </div>

      {/* Search */}
      <input
        type="text"
        placeholder="🔍 Search projects..."
        className="mb-6 w-full max-w-sm px-4 py-2 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 outline-none"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {/* Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
        {filteredProjects.map((p) => {
          const color = getColor(p.projectName);

          return (
            <div
              key={p.projectNo}
              
              onClick={async () => {
  try {

     sessionStorage.clear();
    // ✅ call backend to create session
    const session = await SessionAPI.create(
      p.projectNo,
      //userName || ""
       Number(userNo)
    );

   
    setSessionNo(session.sessionNo);


setSessionNo(session.sessionNo);

setTimeout(() => {
  navigate(`/project/${p.projectNo}`, {
    state: {
      projectName: p.projectName,
    },
  });
}, 50);



  } catch (err) {
    console.error(err);
    alert("Session creation failed");
  }
}}

              className="
                bg-white rounded-2xl shadow-md hover:shadow-xl
                transition-all duration-200 cursor-pointer
                overflow-hidden group
                hover:-translate-y-1
                border border-gray-200 hover:border-blue-400
              "
            >
             
 
 {p.imageUrl ? (
  <div className="relative overflow-hidden">
    <img
      src={p.imageUrl}
      className="w-full aspect-video object-cover transition-transform duration-300 group-hover:scale-105"
      alt={p.projectName}
    />
    <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition" />
  </div>
) : (
  <div
    className={`w-full aspect-video bg-gradient-to-br ${color} flex flex-col justify-end p-4`}
  >
    {/* <h2 className="text-white font-semibold text-lg truncate"> */}

    <h2 className="text-white truncate">
      {p.projectName}
    </h2>
    {/* <p className="text-white/70 text-xs"> */}
    <p className="text-white/70">
    Project</p>
  </div>
)}
              {/* Content */}
              <div className="p-3 bg-gray-50 space-y-1">
                {/* <h2 className="text-sm font-semibold text-gray-800 truncate group-hover:text-blue-600 transition"> */}
                <h2 className="text-gray-800 truncate group-hover:text-blue-600 transition">
                  {p.projectName}
                </h2>

                {/* ✅ Metadata */}
                {p.startDate && (
                  // <p className="text-xs text-gray-500">
                  <p className="text-gray-500">
                    {new Date(p.startDate).toLocaleDateString()}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Empty */}
      {filteredProjects.length === 0 && (
        <div className="text-center text-gray-400 mt-10">
          No projects found
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center">
          <div className="bg-white p-6 rounded-2xl w-full max-w-md shadow-2xl">

            {/* <h2 className="text-xl font-semibold mb-4"> */}
            <h2 className="mb-4">
              Create Project Details
            </h2>


            <label className="block mb-1 font-medium text-gray-700">
  Project Name
</label>
            <input
              type="text"
              placeholder="Enter Project Name"
              className="w-full border p-2 mb-3 rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
              value={form.projectName}
              onChange={(e) =>
                setForm({ ...form, projectName: e.target.value })
              }
            />

<label className="block mb-1 font-medium text-gray-700">
  Project Description
</label>
            <input
              type="text"
              placeholder="Enter Project Description"
              className="w-full border p-2 mb-3 rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
              value={form.projectDescription}
              onChange={(e) =>
                setForm({ ...form, projectDescription: e.target.value })
              }
            />
            <label className="block mb-1 font-medium text-gray-700">
  Start Date
</label>
            <input
              type="date"
              className="w-full border p-2 mb-3 rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
              value={form.startDate}
              onChange={(e) =>
                setForm({ ...form, startDate: e.target.value })
              }
            />
<label className="block mb-1 font-medium text-gray-700">
  Project Image
</label>
            <input
              type="file"
              accept="image/*"
              className="w-full border p-2 mb-3 rounded-lg bg-white"
              onChange={(e) =>
                setForm({ ...form, image: e.target.files?.[0] || null })
              }
            />

            {form.image && (
              <img
                src={URL.createObjectURL(form.image)}
                className="w-20 h-20 rounded-full object-cover mb-3"
              />
            )}

            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowModal(false)}
                className="bg-gray-300 px-4 py-2 rounded-lg"
              >
                Cancel
              </button>

              <button
                onClick={handleCreate}
                disabled={loading}
                className="bg-green-600 text-white px-4 py-2 rounded-lg"
              >
                {loading ? "Creating..." : "Create"}
              </button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default Projects;

